module.exports = __webpack_public_path__ + "img/icon-sti-sti-dest-pod-overdue.033ccf43.svg";